import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import { useTranslate } from "react-translate";
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import classnames from 'classnames';

import DoctorReview from "components/Laboratories/DoctorReview";
import DoctorsService from "services/DoctorsService";
import { 
    actionGetStudy, 
    actionSetFromDetailsLabor
} from "store/actions/laboratoryActions";
import { actionInvitePatient } from 'store/actions/patientsActions';
import ScrollButton from "components/Common/ScrollButton";
import StudyAnalytes from "components/Laboratories/StudyAnalytes";
import LaboratoryContext from "components/Common/Laboratory/LaboratoryContext";

const LaboratoryDetail = () => {
    const dispatch = useDispatch();
    const { reportId } = useParams("reportId");
    const labReducer = useSelector(state => state.laboratoryReducer);
    const { study, loadingAiReview, loadingStudy } = labReducer;
    const history = useHistory();
    const t = useTranslate('laboratory-detail');
    const { nativeWebView } = useSelector(state => state.commonReducer);
    const { practice } = useSelector(state => state.practicesReducer);
    const [review, setReview] = useState('');
    const { doctorInfo } = useSelector(state=>state.userDataReducer);
    const [aiFlag, setAiFlag] = useState(false);
    const [oldModal, setOldModal] = useState(false);
    const [readAiComment, setReadAiComment] = useState(false);
    const [systemTemplates, setSystemTemplates] = useState([]);

    const [canVote, setCanVote] = useState(
        typeof study.ai_review_voted  !== "undefined"
        ? !study.ai_review_voted 
        : false
    );
    
    const [activeTab, setActiveTab] = useState('1');

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const fetchTemplates = async () => {
        const { data } = await DoctorsService.getSystemTemplates();
        setSystemTemplates(data);
    }

    useEffect(() => {
        fetchTemplates();
    }, []);
    
    useEffect(() => {
        dispatch(actionGetStudy(reportId, practice._id, doctorInfo.ai_feature_enabled));
    }, [reportId, doctorInfo]);

    const invitePatient = (patientId) => {
        dispatch(actionInvitePatient(patientId, doctorInfo.doctor_pifs_id, reportId));
    }

    useEffect(() => {
        if (!loadingStudy && study?.is_old && !oldModal) {
            setOldModal(true);
        }

        if (Object.keys(study).length) {
            setCanVote(
                typeof study.ai_review_voted  !== "undefined"
                ? !study.ai_review_voted 
                : false
            );
        }
    }, [loadingAiReview, study]);

    const patientExists = Object.keys(study).length && study.patient.isTelepraxen === 1;

    return (
        <div>
            
            <ScrollButton minScroll={600} condition={activeTab === "1"} />

            <Card>
                <CardBody>
                    <Card>

                        <CardHeader>
                            <CardTitle className="d-flex align-content-center">
                                <div className="general-card-title-img text-primary mr-2">
                                <i className="icon-microscope" />
                                </div>
                                <div className="general-card-title text-primary">
                                    {t('laboratory-details')}
                                </div>
                            </CardTitle>
                        </CardHeader>

                        {loadingStudy ? (<LoadingLocal />)
                            : (

                                <CardBody>

                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <Button
                                                size="md"
                                                color="info"
                                                testId="go-back-btn"
                                                onClick={
                                                    (e) => {
                                                        e.preventDefault();
                                                        dispatch(actionSetFromDetailsLabor(true));
                                                        history.push(`/admin/lab-studies`);
                                                    }
                                                }>
                                                {t('go-back')}
                                            </Button>
                                        </div>

                                        <div className="d-flex flex-column">
                                            {doctorInfo.ai_feature_enabled ? (
                                                <>
                                                    {patientExists ? (
                                                        <>
                                                            <span testId="patient-registered" className="badge badge-success mt-3">
                                                                {t('patient-registered')}
                                                            </span>
                                                            <span className="badge badge-save-info">
                                                                {t('info-badge-save')}
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </>
                                            ) : (<></>)}


                                            {patientExists && oldModal && (
                                                <span className="badge badge-study-old">
                                                    {t('study-older')}
                                                </span>
                                            )}

                                        </div>


                                        {Object.keys(study).length ? (
                                            <>
                                            {!study.patient.isTelepraxen ? (
                                                <Button 
                                                    testId="invite-patient"
                                                    color={`primary ${doctorInfo.ai_feature_enabled ? "ml-2" : ""}`} 
                                                    onClick={() => {invitePatient(study.patient.patient_pifs_id)}}
                                                >
                                                    {t('patient-not-registered')}
                                                    <i className="icon icon-send ml-2"></i>
                                                </Button>
                                            ) : study.patient.isTelepraxen === 2 ? (
                                                <Button 
                                                    testId="invite-patient"
                                                    color={`default ${doctorInfo.ai_feature_enabled ? "ml-2" : ""}`} 
                                                    onClick={() => {invitePatient(study.patient.patient_pifs_id)}}
                                                >
                                                    {t('patient-not-registered')}
                                                    <i className="icon icon-send ml-2"></i>
                                                </Button>
                                            ) : (<></>)}
                                                
                                            </>
                                        ) : (<></>)}

                                    </div>
                                    

                                    <div className="mt-2">
                                        {
                                            study.metadata && study.patient && (
                                                <LaboratoryContext 
                                                    view={"labor"}
                                                    setActiveTab={setActiveTab}
                                                    tabId={"2"}
                                                    setMasterEdited={() => {}}
                                                    setCanSend={() => {}}
                                                    canVote={canVote}
                                                />
                                            )
                                        }
                                        {/* <textarea name="" id="" cols="60" rows="10"></textarea> */}

                                        {study.ai_review_error && (
                                            <div className="ai-loading-error">
                                                Die KI-Engine ist nicht verfügbar. <br/> Bitte versuchen Sie in ein paar Minuten, das Studio zu betreten.
                                            </div>
                                        )}
                                    </div>

                                    {/*
                                    <div className="d-flex flex-row-reverse">
                                        {loadingAiReview ? (
                                            <div testID="ai-loading-indicator" className="ai-loading">
                                                <LoadingLocal/>
                                                KI-Kommentar wird generiert...
                                            </div>
                                        ) : (<></>)}
                                    </div>
                                    */}

                                    

                                    <Nav pills className="nav-pills-primary mb-4 mt-4">
                                        <NavItem className="profile-item">
                                            <NavLink
                                                testId="detail-pill-nav"
                                                className={classnames({ active: activeTab === '1' })}
                                                onClick={() => {
                                                    toggle('1');
                                                }}>
                                                    {t('tab-detail')}
                                            </NavLink>
                                        </NavItem>

                                        
                                        <NavItem className="profile-item">
                                            <NavLink
                                                testId="review-pill-nav"
                                                className={classnames({ active: activeTab === '2' })}
                                                onClick={() => {
                                                    toggle('2');
                                                }}>
                                                    {t('tab-doctor-review')}
                                            </NavLink>
                                        </NavItem>
                                    </Nav>

                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId="1">
                                            <StudyAnalytes 
                                                study={study}
                                                reportId={reportId}
                                                nativeWebView={nativeWebView}
                                            />
                                        </TabPane>

                                        <TabPane tabId="2">
                                            <DoctorReview 
                                                study={study} 
                                                reportId={reportId} 
                                                review={review} 
                                                setReview={setReview}
                                                aiFlag={aiFlag} 
                                                setAiFlag={setAiFlag}
                                                readAiComment={readAiComment}
                                                setReadAiComment={setReadAiComment}
                                                systemTemplates={systemTemplates}
                                            />
                                        </TabPane>
                                    </TabContent>

                                </CardBody>
                            )}
                    </Card>
                </CardBody>
            </Card >
        </div >
    );
};

export default LaboratoryDetail;